import { Injectable, inject } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({ providedIn: "root" })
export class GetWalletWS {
  private readonly baseHandler = inject(BaseHandler);

  execute(token: string): Observable<Record<string, any>> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_WALLET_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.baseHandler.execute(parameters);
  }
}
